import { DropDownList } from "@progress/kendo-react-dropdowns";
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import VehicleTransportModel from "../../models/masters/vehicletransport-model";
import * as Yup from "yup";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetVehicleTransports } from "../../apiclient/master/useGetVehicleTransportApi";
  
interface VehicleTransportEditProps {
    data: VehicleTransportModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
  }


const VehicleTransportEntry: React.FC<VehicleTransportEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.vehicleTransportId > 0 ? "Edit Vehicle Transport" : "Add Vehicle Transport";
  
    let initialValue: VehicleTransportModel = {
        vehicleTransportId: data?.vehicleTransportId? data.vehicleTransportId:0,    
        name: data?.name,
        contactPerson: data?.contactPerson,
        mobile: data?.mobile,
        alternateMobile: data?.alternateMobile,
        address: data?.address,
        isActive: data?.vehicleTransportId > 0 ? data.isActive : true,
      };
    const validationSchema = Yup.object().shape({
      contactPerson: Yup.string().required("Required"),
      mobile: Yup.string().required("Required"),
      name: Yup.string()
      .required("Required")
      .test("check-duplicate-name", "Vehicle Transport name already exists", (value) => {
        // Ensure the value is compared in a case-insensitive manner
        return (
          value &&
          !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
          (data?.name && value === data.name) // Allow current name during update
        );
      }), 
});
console.log(initialValue)


const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
const { data: fetchedVehicleTransport } = useGetVehicleTransports(); // Fetching existing zones data

useEffect(() => {
  if (fetchedVehicleTransport) {
      setExistingName(fetchedVehicleTransport.map((zone: any) => zone.name)); // Extracting zone names to compare against
  }
}, [fetchedVehicleTransport]);
  
   
    return (
      <>
        <FormikModelDialog
          width="50%"
          title={title}
          initialData={initialValue}
          validationSchema={validationSchema}
          show={!!data}
          onClose={onClose}
          endpoint={API_END_POINT.MASTER}
          showAddAnother={true}
          postRoute="VehicleTransport/SaveVehicleTransport"
          isViewOnly ={isViewMode}
          isUpDateEntityDetails={data?.vehicleTransportId>0? true: false}

        >
           <div>
          <div className="row">
            <div className="col-4">
              <InputField maxLength={100} label="Vehicle Transport *" name="name" />
            </div>
            <div className="col-6">
              <InputField maxLength={100} label="Contact Person *" name="contactPerson" />
            </div>
            <div className="col-6">
             
             <InputField maxLength={10}
              label="Mobile *"
               name="mobile" />
              </div>
              <div className="col-6">

               <InputField maxLength={10}
              label="Alternate Mobile"
               name="alternateMobile" />
               </div>

                <div className="col-6">

               <InputField maxLength={150}
              label="Address"
               name="address" />
           </div>
           <div className="col-12">
                  <CheckboxField  isChecked={true} label="Is Active?" name="isActive"  checkstyle={CheckBoxStyle.Normal} />
              </div>        
                </div>
                

          
        </div>
        </FormikModelDialog>
      </>
    );
  };


  export default VehicleTransportEntry;